export enum EncounterStatus {
  EncounterCreated = 1,
  EncounterDraft = 2,
  EncounterModify = 3,
  Certified = 4,
  Approved = 5,
  Rejected = 6,
  Overdue = 7,
  In_Review = 8,
}
